<app-modal-title>
  <div class="otsc-rollback-title">
    <div class="otsc-rollback-title__icon"></div>
    <div class="otsc-rollback-title__text" i18n>Performing software rollback</div>
  </div>
</app-modal-title>
<app-modal-body >
  @if (loading) {
    <div [ngStyle]="{'height': (targetSystemsBusy || offlineAgents.length > 0) ? '400px' : height}">
      <div class="ot-progress-container ot-pt-5">
        <div id="ot-spinner-text" class="ot-progress ot-progress--is-spinner ot-progress--is-spinner-has-text">
          <div class="ot-progress__outer">
            <div class="ot-progress__meter">
            </div>
          </div>
          <div class="ot-progress__text" i18n>Loading...</div>
        </div>
      </div>
    </div>
  }
  @if (isError) {
    <div class="ot-message ot-message--is-error w-100">
      <div class="ot-message__banner">
        <p class="ot-message__item">
          {{errorMessage}}
        </p>
      </div>
    </div>
  }
  @if (!loading) {
    <div class="ot-pl-1 ot-pr-1 ot-pt-1 ot-pb-1">
      <b i18n>Do you wish to proceed with software rollback?</b>
      <p i18n>Note: Database changes will need to be restored by a database administrator using a backup taken prior to the start of the update process. Software rollback only restores changes made by the current deployment. Any changes made outside of this deployment will need to be rolled back manually.</p>
      @if (offlineAgents.length > 0) {
        <div>
          <div class="ot-message ot-message--is-warning">
            <div class="ot-message__banner">
              <p class="ot-message__item" i18n>
                        The agent on the following system(s) must be running:
                    </p>
            </div>
          </div>
          <ul class="ot-list ot-list--is-medium-density ot-pt-1">
            @for (agent of offlineAgents; track agent) {
              <li tabindex="-1" class="ot-list__item">
                <span>{{agent}}</span>
              </li>
            }
          </ul>
        </div>
      }
      @if (targetSystemsBusy) {
        <div>
          <div class="ot-message ot-message--is-error">
            <div class="ot-message__banner">
              <p class="ot-message__item" i18n>
                        Software rollback request could not be processed. The agents are busy running other activities. Please try again later.
                    </p>
            </div>
          </div>
        </div>
      }
    </div>
  }
</app-modal-body>
<app-modal-footer>
  @if (!rollbackComplete) {
    <button id="rollback-activities-yes-btn" class="ot-btn ot-btn--is-primary" [title]="rollbackBtnText" (click)="rollback()" [disabled]="isRollingback" >
      {{rollbackBtnText}}
    </button>
  }
  @if (rollbackComplete) {
    <button id="rollback-activities-close-btn" class="ot-btn ot-btn--is-primary" i18n-title title="Close" (click)="close()" i18n>
        Close
    </button>
  }
  @if (!rollbackComplete) {
    <button id="rollback-activities-no-btn" class="ot-btn" i18n-title title="No" [disabled]="isRollingback" (click)="close()" i18n>
        No
    </button>
  }
</app-modal-footer>